module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_moducom_m.d0df585dbb6640e24e282f583b443993.png";